/* Assets/promo-grid.js */

document.addEventListener('DOMContentLoaded', () => {
  // Seleziona tutti i contenitori che hanno slide dentro
  const sliders = document.querySelectorAll('.grid-slider, .side-slider');

  sliders.forEach(slider => {
    const track = slider.querySelector('.slider-track');
    const slides = slider.querySelectorAll('.slide');
    const dotsContainer = slider.querySelector('.slider-dots');
    
    // Se c'è una sola slide, nascondi dots e non attivare loop
    if (slides.length <= 1) {
      if(dotsContainer) dotsContainer.style.display = 'none';
      return; 
    }

    let currentIndex = 0;
    let autoPlayInterval;
    // Legge la velocità dall'HTML o usa 6000ms di default
    const delay = parseInt(slider.getAttribute('data-autoplay-speed')) || 6000;

    // Crea Dots
    if (dotsContainer) {
      dotsContainer.innerHTML = ''; 
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('dot');
        if (index === 0) dot.classList.add('active');
        dot.addEventListener('click', () => {
          goToSlide(index);
          resetTimer();
        });
        dotsContainer.appendChild(dot);
      });
    }

    const dots = dotsContainer ? dotsContainer.querySelectorAll('.dot') : [];

    function goToSlide(index) {
      if (!track) return;
      track.style.transform = `translateX(-${index * 100}%)`;
      
      if (dots.length) {
        dots.forEach(d => d.classList.remove('active'));
        if(dots[index]) dots[index].classList.add('active');
      }
      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      goToSlide(nextIndex);
    }

    function startTimer() {
      clearInterval(autoPlayInterval);
      autoPlayInterval = setInterval(nextSlide, delay);
    }

    function resetTimer() {
      clearInterval(autoPlayInterval);
      startTimer();
    }

    // Stop su hover (desktop) o touch (mobile)
    slider.addEventListener('mouseenter', () => clearInterval(autoPlayInterval));
    slider.addEventListener('mouseleave', startTimer);
    slider.addEventListener('touchstart', () => clearInterval(autoPlayInterval), {passive: true});
    slider.addEventListener('touchend', startTimer);

    // Avvio
    startTimer();
  });
});